import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import {FileCopy} from '@material-ui/icons';
import PropTypes from 'prop-types';
import {formatErrors} from '../../actions/errors';
import {addFlashMessage} from '../../actions/flash-message';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {createForm} from 'rc-form';

export class QuizShare extends React.Component {

    static propTypes ={
        selectedQuiz: PropTypes.string.isRequired,
    };

    copyToClipboard(){
        const {addFlashMessage} = this.props;
        this.textArea.select();
        let success = document.execCommand('copy');
        this.textArea.focus();
        if (success) {
            addFlashMessage('Quiz link copied', 'success');
        }
        else {
            addFlashMessage('Quiz link not copied. Please try manually copying the link', 'error');
        }
    }

    componentDidMount() {
        this.copyToClipboard();
    }

    render(){
        return (
            <div className='share-modal'>
                <input type='text' value={`${window.location.origin}/quizzes/${this.props.selectedQuiz}/take`} readOnly={true} ref={(textarea) => this.textArea = textarea} />
                <IconButton href={null} onClick={this.copyToClipboard.bind(this)}><FileCopy/></IconButton>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default withRouter(connect(
    null,
    mapDispatchToProps
)(QuizShare));